/* @flow */
import React from 'react';
// $FlowIgnore
import { MdComment } from 'react-icons/md';

export default function AnnotationIcon({
  style
}: Object): React.Element {
  return <MdComment style={style} />;
}
